import React from 'react';

function CustomPagination({
  current, totalPages, setCurrent, pagingContainer,
}) {
  const pageNumbers = [];
  const visiblePages = 4;

  let startPage = Math.max(1, current - Math.floor(visiblePages / 2));
  let endPage = Math.min(totalPages, current + Math.floor(visiblePages / 2));

  if (endPage - startPage < visiblePages - 1) {
    if (startPage === 1) {
      endPage = Math.min(totalPages, startPage + visiblePages - 1);
    } else {
      startPage = Math.max(1, endPage - visiblePages + 1);
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(
      <a
        key={i}
        className={`page-numbers ${i === current ? 'current' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          setCurrent(i);
        }}
        href="#"
        aria-current={i === current ? 'page' : undefined}
      >
        {i}
      </a>,
    );
  }

  return (
    <div className={`navigation pagination ${pagingContainer}`}>
      <h2 className="screen-reader-text">Jobs Navigation</h2>
      <div className="nav-links">
        <a
          className={`prev page-numbers ${current === 1 ? 'disabled' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            if (current !== 1) { // Only call setCurrent if not on the first page
              setCurrent(current - 1);
            }
          }}
          href={current === 1 ? null : '#'}
          aria-disabled={current === 1 ? 'true' : 'false'}
        >

        </a>
        {startPage > 1 && (
          <>
            <a className="page-numbers" onClick={(e) => { e.preventDefault(); setCurrent(1); }} href="#">1</a>
            {startPage > 2 && <span className="page-numbers dots">…</span>}
          </>
        )}
        {pageNumbers}

        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <span className="page-numbers dots">…</span>}
            <a className="page-numbers" onClick={(e) => { e.preventDefault(); setCurrent(totalPages); }} href="#">{totalPages}</a>
          </>
        )}

        <a
          className={`next page-numbers ${current === totalPages ? 'disabled' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            if (current !== totalPages) {
              setCurrent(current + 1);
            }
          }}
          href={current === totalPages ? null : '#'}
          aria-disabled={current === totalPages ? 'true' : 'false'}
        >

        </a>
      </div>
    </div>
  );
}

export default CustomPagination;
